<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_threat') : $t('labels.add_threat') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="threat_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.threat_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('threat_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 mt-4">
              <label>{{ $t('labels.preventative_barriers')}}</label>
              <v-select
                multiple
                name="preventative_barrier"
                v-model="parent_id"
                :options="parentSection"
                :reduce="parentSection => parentSection.id"
                label="name"
                :closeOnSelect="false"
                class="mt-1"
              />
            </div>
          </div>
          <div class="mt-6 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-threat"
              button="submit"
            >{{ editRoute ? $t('labels.update_threat') : $t('labels.add_threat') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      parent_id: [],
      parentSection: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getPreventativebarriers();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getThreats();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateThreats();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdateThreats() {
      let input = {
        name: this.name,
        preventative_barrier_ids: this.parent_id
      };
      let url = this.editRoute
        ? "/threats/update/" + this.editRoute
        : "/threats/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-threat",
        true
      );
      if (response) {
        this.$router.push({ name: "Threats" });
      }
    },
    async getThreats() {
      let response = await this.getHTTPGetResponse(
        "/threats/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let threats = data.threat;
        this.name = threats.name;
        let filteredSection = [];
        for (var i = 0; i < threats.preventative_barriers.length; i++) {
          filteredSection.push(threats.preventative_barriers[i].id);
        }
        this.parent_id = filteredSection;
      }
    },
    async getPreventativebarriers() {
      let input = {
        name: this.parent_id
      };
      let response = await this.getHTTPPostResponse(
        "/preventative-barriers/list",
        input
      );
      if (response) {
        let preventative_req = response.data.preventative_barriers;
        let filteredSection = [];
        for (var i = 0; i < preventative_req.length; i++) {
          let obj = {
            id: preventative_req[i].id,
            name: preventative_req[i].name
          };
          filteredSection.push(obj);
        }
        this.parentSection = filteredSection;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>